import { render } from "./HelpHeader.vue?vue&type=template&id=396db424&scoped=true"
import script from "./HelpHeader.vue?vue&type=script&lang=js"
export * from "./HelpHeader.vue?vue&type=script&lang=js"

import "./HelpHeader.vue?vue&type=style&index=0&id=396db424&lang=scss&scoped=true"

import exportComponent from "/app/tmp/bambl/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396db424"]])

export default __exports__